import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["portalId", "authenticatorId", "appName", "appId", "oAuthScope", "mcp", "onComplete", "onCancel", "shouldDeleteOnFailure", "introScreen", "successScreen"];
import { useState } from 'react';
import UnifiedAccountModal from './UnifiedAccountModal';
import { deleteAccount } from './UnifiedAccountApi';
import { Button } from 'foundations-components/transitional/components/Button';

// DO NOT USE THIS COMPONENT YET.
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};

// DO NOT USE THIS COMPONENT YET.
export function UnifiedAccountButton(_ref) {
  let {
      portalId,
      authenticatorId,
      appName,
      appId,
      oAuthScope,
      mcp,
      onComplete,
      onCancel = noop,
      shouldDeleteOnFailure,
      introScreen,
      successScreen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showAuthModal, setShowAuthModal] = useState(false);
  function closeModal() {
    setShowAuthModal(false);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      onClick: clickEvent => {
        setShowAuthModal(true);
        if (props.onClick) {
          props.onClick(clickEvent);
        }
      }
    })), showAuthModal && /*#__PURE__*/_jsx(UnifiedAccountModal, {
      portalId: portalId,
      authenticatorId: authenticatorId,
      appName: appName,
      appId: appId,
      oAuthScope: oAuthScope,
      mcp: mcp,
      onComplete: accountId => {
        let onCompleteSucceeded = false;
        try {
          onComplete(accountId);
          onCompleteSucceeded = true;
        } catch (err) {
          const shouldCleanup = shouldDeleteOnFailure ? shouldDeleteOnFailure(accountId) : true;
          if (shouldCleanup) {
            // This is intentionally fire and forget.
            // Delete the account that was created to prevent orphaned accounts on failure
            void deleteAccount(accountId);
          }
          throw err;
        } finally {
          // Auto-close modal only if no custom success screen is provided
          if (onCompleteSucceeded && !successScreen) {
            closeModal();
          }
        }
      },
      onCancel: () => {
        closeModal();
        onCancel();
      },
      introScreen: introScreen,
      successScreen: successScreen
    })]
  });
}
export default UnifiedAccountButton;